module.exports = __webpack_public_path__ + "65a117cda4480eac54940a438bc286d1.svg";